import { WebchatConfiguration, WebchatConfigurationKeys } from './types';

const prodConfig: WebchatConfiguration = {
  [WebchatConfigurationKeys.APP_INSIGHTS_CONNECTION_STRING]:
    'InstrumentationKey=af151b03-818a-47b0-b653-490b8043fc93;IngestionEndpoint=https://northeurope-0.in.applicationinsights.azure.com/',
  [WebchatConfigurationKeys.GOOGLE_TAG_MANAGER_KEY]: 'GTM-TL544CP',
};

export default prodConfig;
